/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const ABCSquares = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
    data-palette="ABCSquares">
    <mask
      id="a"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={24}
      height={24}
    >
      <path fill="#D9D9D9" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        d="M12.511 7.992H10.79l-.32.92H9.294l1.798-4.736h1.134l1.803 4.736h-1.198l-.32-.92Zm-.337-.988L11.65 5.49l-.523 1.515h1.047Z"
        fill="#fff"
      />
      <rect
        x={6.588}
        y={1.471}
        width={10.147}
        height={10.147}
        rx={0.676}
        stroke="#fff"
        strokeWidth={2}
        mask="url(#path-2-inside-1_604_339)"
      />
      <path
        d="M7.161 17.943c.244.094.435.243.573.446.138.198.207.44.207.724 0 .415-.15.735-.45.96-.301.226-.736.339-1.305.339H3.882v-4.735h2.182c.545 0 .959.112 1.243.338.285.22.427.52.427.9 0 .225-.05.428-.152.608a1.076 1.076 0 0 1-.42.42Zm-2.084-1.3v.914h.829c.406 0 .61-.153.61-.46 0-.302-.204-.453-.61-.453h-.83Zm1.011 2.801c.423 0 .634-.16.634-.48 0-.32-.211-.48-.634-.48H5.077v.96h1.011Z"
        fill="#fff"
      />
      <rect
        x={0.5}
        y={12.971}
        width={10.823}
        height={10.147}
        rx={0.676}
        stroke="#fff"
        strokeWidth={2}
        mask="url(#path-4-inside-2_604_339)"
      />
      <path
        d="M18.337 20.412c-.434 0-.825-.1-1.172-.3a2.184 2.184 0 0 1-.81-.845 2.502 2.502 0 0 1-.296-1.223c0-.455.098-.863.296-1.223.197-.36.467-.64.81-.839a2.27 2.27 0 0 1 1.172-.305c.378 0 .72.073 1.023.22.304.148.556.36.758.638l-.746.742c-.268-.356-.593-.534-.976-.534-.225 0-.426.054-.604.163-.173.108-.31.262-.408.462-.095.195-.142.42-.142.676 0 .256.047.484.142.683.099.195.235.347.408.455.178.109.38.163.604.163.383 0 .708-.178.976-.533l.746.741c-.201.278-.454.49-.758.638a2.314 2.314 0 0 1-1.023.22Z"
        fill="#fff"
      />
      <rect
        x={12.677}
        y={12.971}
        width={10.823}
        height={10.147}
        rx={0.676}
        stroke="#fff"
        strokeWidth={2}
        mask="url(#path-6-inside-3_604_339)"
      />
    </g>
  </svg>
);

export default ABCSquares;
